import { Box, Stack } from '@chakra-ui/react';

import type { AssignmentFormData } from '../../types/assignmentTypes';
import AssignmentFormPreviewHeader from './AssignmentFormPreviewHeader';
import NoNotificationsPlaceholder from '../../notifications/NoNotificationsPlaceholder';
import NotificationsListItem from '../../notifications/NotificationsListItem';
import { PaperPlane2 } from '@/client/components/icons/ContinuIcons';
import { useTranslation } from 'react-i18next';

interface NotificationsFormPreviewProps {
  settings: AssignmentFormData['settings'];
  renderStatus?: boolean;
  isModalPreview?: boolean;
}

export default function NotificationsFormPreview({
  settings,
  renderStatus = false,
  isModalPreview = false,
}: NotificationsFormPreviewProps) {
  const { t } = useTranslation();

  const { reminderMessages, nonReminderMessages, overdueMessages } = settings;

  const allNotifications = [...reminderMessages, ...nonReminderMessages, ...overdueMessages];

  return (
    <Box>
      <AssignmentFormPreviewHeader
        formName="notifications"
        icon={PaperPlane2}
        title={t('notifications.notifications')}
        renderStatus={renderStatus}
      />

      {allNotifications.length === 0 && (
        <Box padding={6}>
          <NoNotificationsPlaceholder />
        </Box>
      )}

      {allNotifications.length > 0 && (
        <Stack
          spacing={4}
          paddingY={isModalPreview ? 0 : 6}
          paddingX={isModalPreview ? 0 : 6}
          borderTop="1px solid"
          borderTopColor={isModalPreview ? 'transparent' : 'neutral.100'}
        >
          {allNotifications.map((notification, index) => {
            const id = 'message' in notification ? notification.message.id : notification.id;

            return (
              <NotificationsListItem
                key={id}
                variant="neutral"
                notification={notification}
                renderDivider={index < allNotifications.length - 1}
              />
            );
          })}
        </Stack>
      )}
    </Box>
  );
}
